import { render, staticRenderFns } from "./_base-requester-email.vue?vue&type=template&id=1bfc3b59&"
import script from "./_base-requester-email.vue?vue&type=script&lang=js&"
export * from "./_base-requester-email.vue?vue&type=script&lang=js&"
import style0 from "./_base-requester-email.vue?vue&type=style&index=0&id=1bfc3b59&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports